import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className="ri-live-line text-3xl" />
      </span>
      <p className="mt-6 font-heading text-6xl font-extrabold text-primary-500">404</p>
      <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950">
        页面走丢了
      </h1>
      <p className="mt-2 text-sm text-foreground-500">
        找不到路径 <span className="font-mono text-foreground-700">{location.pathname}</span>
      </p>
      <Link
        to="/"
        className="mt-6 flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
      >
        <i className="ri-home-4-line text-base" />
        返回首页
      </Link>
    </div>
  );
}